// components/CalificacionesManager.js
import React, { useState } from "react";
import {
  Button,
  Input,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
  Label
} from "reactstrap";
import { PlusCircle, Sparkles } from "lucide-react";
import {
  postTypifications,
  postAutomationRules,
  getStates
} from "../../../helpers/backend";
import "./styles/Typifications.css";

const CalificacionesManager = ({ campaign, onSaved }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [newCalif, setNewCalif] = useState({
    name: "",
    descripciones: [],
    descripcionText: ""
  });
  const [autoModal, setAutoModal] = useState(false);
  const [selectedDesc, setSelectedDesc] = useState(null);
  const [ruleData, setRuleData] = useState({
    etapa_destino: "",
    estado_destino: ""
  });
  const [states, setStates] = useState([]);

  const loadStates = async () => {
    const res = await getStates();
    setStates(res.data.results || []);
  };

  const openAutoModal = (desc) => {
    setSelectedDesc(desc);
    setRuleData({ etapa_destino: "", estado_destino: "" });
    setAutoModal(true);
    loadStates();
  };

  const handleAddDescripcion = () => {
    if (!newCalif.descripcionText.trim()) return;
    setNewCalif((prev) => ({
      ...prev,
      descripciones: [...prev.descripciones, prev.descripcionText.trim()],
      descripcionText: ""
    }));
  };

  const handleSaveCalificacion = async () => {
    if (!newCalif.name.trim() || newCalif.descripciones.length === 0) return;

    const payload = [
      {
        campaign_id: campaign.id,
        calificaciones: [
          {
            name: newCalif.name.trim(),
            descripciones: newCalif.descripciones
          }
        ]
      }
    ];
      console.log(payload)
    try {
      await postTypifications(payload);
      setModalOpen(false);
      setNewCalif({ name: "", descripciones: [], descripcionText: "" });
      onSaved?.();
    } catch (error) {
      alert("Error al guardar la calificación");
    }
  };

  const handleCreateAutomation = async () => {
    const payload = [
      {
        descripcion_calificacion: selectedDesc.id,
        etapa_destino: ruleData.etapa_destino || null,
        estado_destino: ruleData.estado_destino || null,
        pipeline: campaign.pipeline?.id
      }
    ];

    try {
      await postAutomationRules(payload);
      setAutoModal(false);
      onSaved?.();
    } catch (err) {
      alert("Error al guardar automatización");
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="section-title">Resultados()</h5>
        <Button color="success" onClick={() => setModalOpen(true)}>
          <PlusCircle className="me-1" size={18} />
          Nuevo Resultado
        </Button>
      </div>

      <div className="calif-grid">
        {campaign.calificaciones.map((cal) => (
          <div className="calif-card" key={cal.id}>
            <h6 className="calif-title">{cal.name}</h6>

            <ul className="desc-list">
              <span className="font-size-12 text-dark">Calificaciones</span>
              {cal.descripciones.map((desc) => (
                <li key={desc.id} className="desc-item">
                  <div className="desc-container">
                    <div className="desc-header">
                      <span>{desc.name}</span>
                      <span
                        className="sparkle-icon"
                        title="Automatizar"
                        onClick={() => openAutoModal(desc)}
                      >
                        <Sparkles size={18} />
                      </span>
                    </div>

                    {desc.tipificaciones_etapa?.length > 0 && (
                      <div className="desc-rules animated-rule">
                        {desc.tipificaciones_etapa.map((rule) => (
                          <React.Fragment key={rule.id}>
                            {rule.etapa_destino && (
                              <span
                                className="rule-pill pill-etapa"
                                title="Etapa destino"
                              >
                                {rule.etapa_destino}
                              </span>
                            )}
                            {rule.estado_destino && (
                              <span
                                className="rule-pill pill-estado"
                                title="Estado destino"
                              >
                                {rule.estado_destino}
                              </span>
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Modal nueva calificación */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Nuevo Resultado
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Nombre</Label>
            <Input
              value={newCalif.name}
              onChange={(e) =>
                setNewCalif({ ...newCalif, name: e.target.value })
              }
            />
          </FormGroup>

          <FormGroup>
            <Label>Agregar Calificación</Label>
            <div className="d-flex">
              <Input
                value={newCalif.descripcionText}
                onChange={(e) =>
                  setNewCalif({ ...newCalif, descripcionText: e.target.value })
                }
              />
              <Button color="primary" onClick={handleAddDescripcion}>
                <PlusCircle size={16} />
              </Button>
            </div>
            <div className="mt-2">
              {newCalif.descripciones.map((d, i) => (
                <Badge key={i} color="secondary" className="me-1  font-size-18" >
                  {d}
                </Badge>
              ))}
            </div>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => setModalOpen(false)} className="text-dark">Cancelar</Button>
          <Button color="primary" onClick={handleSaveCalificacion}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Automatización */}
      <Modal isOpen={autoModal} toggle={() => setAutoModal(false)}>
        <ModalHeader toggle={() => setAutoModal(false)}>
          Nueva Automatización
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Etapa destino</Label>
            <Input
              type="select"
              value={ruleData.etapa_destino}
              onChange={(e) =>
                setRuleData({ ...ruleData, etapa_destino: e.target.value })
              }
            >
              <option value="">-- Seleccionar --</option>
              {campaign.pipeline?.stages.map((stage) => (
                <option key={stage.id} value={stage.id}>
                  {stage.name}
                </option>
              ))}
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>Estado destino</Label>
            <Input
              type="select"
              value={ruleData.estado_destino}
              onChange={(e) =>
                setRuleData({ ...ruleData, estado_destino: e.target.value })
              }
            >
              <option value="">-- Seleccionar --</option>
              {states.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.name}
                </option>
              ))}
            </Input>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => setAutoModal(false)} className="text-dark">Cancelar</Button>
          <Button color="primary" onClick={handleCreateAutomation}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default CalificacionesManager;
